import api from '@/server'
const mutations = {
  LOADING: (state) => {
    state.loading = true;
  },
  SAVEHISTORY: (state, arr) => {
    if (arr.length > 0) {
      state.historySearch = arr;
    } else {
      let history = localStorage.getItem('searchWord');
      if (history) {
        state.historySearch = history.split(',')
      } else {
        state.historySearch = []
      }
    }

  },
  CLEARHISTORY: (state)=> {
    state.historySearch = []
  },
  // 获取购物车列表
  GETCARLIST: (state)=> {
    // 如果用户登录
    if (localStorage.getItem('token')) {
      api.getCarList({
        userId: JSON.parse(localStorage.getItem('userInfo'))._id
      }).then(res=> {
        if(res.code === 200 && res.data.length > 0) {
          state.carList = res.data;
          state.carLength = res.data.length;
          localStorage.setItem('carList', JSON.stringify(res.data));
        } else {
          state.carList = [];
          localStorage.setItem('carList', '');
          state.carLength = 0;
        }
      }).catch(()=> {})
    }
  },
  // 设置购物车长度
  SETCARNUMBER: (state, number) => {
    state.carLength = number
  },
  // 设置登陆提示弹框是否已经被触发
  SETTIP:(state, flag)=> {
    state.flag = flag
  }
};
export default mutations
